// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sodE","tabsBox":"styles_tabsBox__2U7he","createButton":"styles_createButton__7ZUuK"};